export default __webpack_public_path__ + "static/media/drag.145a554b.svg";